
import React from "react";
import { Paper, TableContainer } from "@mui/material";
import { Ship } from "lucide-react";
import OceanTableMapping from "./OceanTableMapping";

function OceanTableView({
  oceanTrackList,
  selectedContainer1,
  selectedContainer,
  billOfLadingUpdatesForTable,
  filteredContainers,
  firstAndLast,
}: {
  oceanTrackList: any;
  selectedContainer1: any;
  selectedContainer: any;
  billOfLadingUpdatesForTable: any[];
  filteredContainers: any;
  firstAndLast: any;
}) {
  return (
    <div className="acMain">
      {oceanTrackList?.type !== "CT" &&
        selectedContainer1 !== "Container" && (
          <div className="paddingo">
            <div className="timelineMainBox mt-4">
              <div className="mt-1">
                <TableContainer
                  className="roadmapTable"
                  component={Paper}
                  sx={{ maxHeight: 400, overflowY: "auto" }}
                >
                  <OceanTableMapping
                    tableData={billOfLadingUpdatesForTable}
                    firstAndLast={firstAndLast}
                  />
                </TableContainer>
              </div>
            </div>
          </div>
        )}

      {selectedContainer1 === "Container" && (
        <div>
          <div className="paddingo">
            <div className="timelineMainBoxoo mt-4">
              {filteredContainers.map((container: any) => {
                const containerNumber = Object.keys(container)[0];

                // ✅ handle both "traking" (typo) and "tracking" (correct)
                const trackingData =
                  container[containerNumber]?.tracking ??
                  container[containerNumber]?.traking;

                const table = container[containerNumber]?.table || [];

                // ✅ ports safely extracted — used if needed downstream
                const ports: any[] = trackingData?.ports || [];

                return (
                  <React.Fragment key={containerNumber}>
                    <div className="timelineMainBox mt-4">
                      <div className="allTAB">
                        {selectedContainer === "All" && (
                          <div className="w-full">
                            <div className="mt-2 mb-5 px-2 py-2 bg-gray-100 text-black rounded-lg flex items-start">
                              <Ship />
                              <p className="ml-2">{containerNumber}</p>
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        key={containerNumber}
                        className="scrollHeightContainernNoscroll"
                      >
                        <TableContainer
                          className="roadmapTable"
                          component={Paper}
                          sx={{ maxHeight: 400, overflowY: "auto" }}
                        >
                          <OceanTableMapping
                            tableData={table}
                            firstAndLast={firstAndLast}
                          />
                        </TableContainer>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OceanTableView;